import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/file_icon.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page_contents" }
const _hoisted_3 = { class: "contents_div" }
const _hoisted_4 = { class: "detail_div" }
const _hoisted_5 = { class: "notice_header_div" }
const _hoisted_6 = { class: "notice_title" }
const _hoisted_7 = { class: "notice_date" }
const _hoisted_8 = { class: "notice_hits" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "notice_file_list"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "notice_btn_div" }

import { onMounted, ref } from "vue";
import resourceBoardAPI from "../api/resourceBoardAPI";
import { useRouter } from "vue-router";
import { ApiResponse, ResourceBoard, ResourceBoardFile, Member } from "../common/types";
import { convertDate } from "../utils/utils";

export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceBoardDetailView',
  setup(__props) {

const router = useRouter();
const resourceBoardData = ref<ResourceBoard>({
  자료순번: 0,
  제목: "",
  조회수: 0,
  내용: "",
  노출여부: "",
  작성자: {} as Member,
  등록자: "",
  등록일시: "",
  수정자: "",
  수정일시: "",
  첨부파일목록: [] as ResourceBoardFile[],
});
onMounted(() => {
  getDetail();
});
const getDetail = () => {
  const seq = Number(router.currentRoute.value.params.seq);
  resourceBoardAPI.getResourceBoard(seq).then((res) => {
    resourceBoardData.value = res.data.data;
  });
};

const getFile = (자료순번: number, 저장순번: number, 파일명: string) => {
  resourceBoardAPI.downloadResourceBoardFile(자료순번, 저장순번, 파일명);
};

// downloadDownloadboardFile(seq: number, index: number, filename: string) {
//         return axiosInstance.get(`/api/anonymous/noticeboards/${seq}/files/${index}`, {
//             responseType: 'blob'
//         }).then((response: any) => {
//             const url = window.URL.createObjectURL(new Blob([response]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', filename); // You can set the file name here
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//         });
//     }

const goPage = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "page_header" }, "자료실", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(resourceBoardData.value.제목), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(convertDate)(resourceBoardData.value.등록일시)), 1),
            _createElementVNode("div", _hoisted_8, "조회 " + _toDisplayString(resourceBoardData.value.조회수), 1)
          ]),
          _createElementVNode("div", {
            class: "notice_contents",
            innerHTML: resourceBoardData.value.내용
          }, null, 8, _hoisted_9),
          (resourceBoardData.value.첨부파일목록?.length != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourceBoardData.value.첨부파일목록, (file, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "notice_file_div",
                    key: index
                  }, [
                    _cache[1] || (_cache[1] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                    _createElementVNode("div", {
                      class: "notice_file_link",
                      onClick: ($event: any) => (getFile(resourceBoardData.value.자료순번, file.저장순번, file.원파일명))
                    }, _toDisplayString(file.원파일명), 9, _hoisted_11)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "back_btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goPage()))
            }, "목록으로")
          ])
        ])
      ])
    ])
  ]))
}
}

})